import { useEffect } from "react";
import { useChatStore } from "@/stores/useChatStore.ts";
import { useAssignedChatStore } from "@/stores/useAssignedChatStore.ts";

// ADD DEFAULT CHAT TO ANY ASSIGNED SESSIONS
// Sometimes a session is assigned, and it may not have a chat created,
// Or hot reloading may wipe chat completely
export const useHookHotLoadingPatch = () => {
  const { AddNewChat } = useChatStore();
  const { assignedSessions } = useAssignedChatStore();

  useEffect(() => {
    const { chats } = useChatStore.getState();
    assignedSessions.forEach((session) => {
      if (chats.get(session.assignedChat.flowGeneratorSessionId)) return;

      AddNewChat({
        flowGeneratorSessionId: session.assignedChat.flowGeneratorSessionId,
      });
    });
  }, [AddNewChat, assignedSessions]);
};
